import { inject, injectable } from 'inversify';
import ReviewsService from '../../data/service/ReviewsService';

type SendOrderReviewUseCaseProps = {
  order_pk: number;
  score: number;
  observation: string;
  tags?: string[];
  accessToken: string;
};

@injectable()
class SendOrderReviewUseCase {
  @inject(ReviewsService) private reviewsService!: ReviewsService;

  async execute({
    order_pk,
    score,
    observation,
    tags,
    accessToken,
  }: SendOrderReviewUseCaseProps) {
    const response = await this.reviewsService.updateReview({
      order_pk,
      score,
      observation,
      tags,
      accessToken,
    });

    return response.data;
  }
}

export default SendOrderReviewUseCase;
